import type { SxProps } from '@mui/material';

export const contentContainerSx = {
  px: { xs: 1.5, md: 3, xl: 4 },
} satisfies SxProps;
